module.exports = __webpack_public_path__ + "static/media/app_crm_v2.5a2c079f.svg";